import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Brand } from '../../components/common/CommonTypes';
import { getSuppressionPageDetails } from '../thunks/getSuppressionContent';

/**
 * Redux slice state for branding information (styles, tag manager ids, payment flags, etc.).
 */
type SliceState = Brand;

/**
 * Initial brand state.
 */
const initialSiteState: SliceState = {
  brandName: '',
  brandStyles: '',
  googleTagManagerId: '',
  worldPay: false,
  openSiteDealerCode: '',
  brandVanityUrl: '',
  brandVanityJourney: -1,
  brandId: 0
};

/**
 * Brand slice containing reducers for storing active brand configuration.
 */
const siteSlice = createSlice({
  name: 'brand',
  initialState: initialSiteState,
  reducers: {
    /** Replaces the entire brand state with the provided payload. */
    setBrand: (_, action: PayloadAction<SliceState>) => action.payload
  },
  extraReducers: (builder) => {
    builder.addCase(getSuppressionPageDetails.fulfilled, (_, action) => {
      return action.payload.brand ?? initialSiteState;
    });
  }
});

export const { setBrand } = siteSlice.actions;

export default siteSlice.reducer;
